import { Stack } from "@mantine/core";
import type { TablerIcon } from "@tabler/icons-react";

interface MenuItemContentProps {
  icon: TablerIcon;
  label: string;
}

function MenuItemContent({ icon, label }: MenuItemContentProps) {
  const TablerIcon = icon;
  return (
    <Stack
      align="center"
      gap={0}
      style={{ whiteSpace: "pre-line" }}
      ta={"center"}
    >
      <TablerIcon size="1.9rem" strokeWidth={1.5} />
      {label}
    </Stack>
  );
}

export { MenuItemContent };
